import { render, staticRenderFns } from "./CourseRegistration.vue?vue&type=template&id=e6fd8b96&scoped=true&"
import script from "./CourseRegistration.vue?vue&type=script&lang=js&"
export * from "./CourseRegistration.vue?vue&type=script&lang=js&"
import style0 from "./CourseRegistration.vue?vue&type=style&index=0&id=e6fd8b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fd8b96",
  null
  
)

export default component.exports